// extracted by mini-css-extract-plugin
module.exports = {"PaddingWrapper":"PaddingWrapper__PaddingWrapper___2Exmf"};